/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IContactInformationDisplayModel {
  emailAddress?: null | string;
  jobtitle?: null | string;
  telephoneNumber?: null | string;
}
export class ContactInformationDisplayModel extends BaseModel implements IContactInformationDisplayModel {
  emailAddress?: null | string;
  jobtitle?: null | string;
  telephoneNumber?: null | string;
}
class BaseContactInformationDisplayModelFormGroup extends FormGroup {
  private static _instance: ContactInformationDisplayModelFormGroup;
  
  public static get Instance(): ContactInformationDisplayModelFormGroup {
    this._instance = new ContactInformationDisplayModelFormGroup({
      emailAddress: new FormControl(null),
      jobtitle: new FormControl(null),
      telephoneNumber: new FormControl(null),
    });

    return this._instance;
  }
}


export class ContactInformationDisplayModelFormGroup extends BaseContactInformationDisplayModelFormGroup {
  public get EmailAddress(): FormControl {
    return this.controls["emailAddress"] as FormControl;
  }
  public get Jobtitle(): FormControl {
    return this.controls["jobtitle"] as FormControl;
  }
  public get TelephoneNumber(): FormControl {
    return this.controls["telephoneNumber"] as FormControl;
  }
  

}

export module ContactInformationDisplayModelForm
  {
    export class FormFields
    {
      static _emailAddress: string = "emailAddress";
      static _jobtitle: string = "jobtitle";
      static _telephoneNumber: string = "telephoneNumber";
    }
  }

